import styled from 'styled-components';

export const ListItemBodyStyled = styled.div`
  margin-left: 16px;
`;
